module.exports = __webpack_public_path__ + "img/icon_map_108_off_111.fa5063d2.png";